export function getProductRoutingEndpoint(): string {
    return '/product-routing';
}
